
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browser-history",
      function () {
        return require("private-next-pages/browser-history/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browser-history"])
      });
    }
  